<div id='scoring_graphics'>
</div>
